import { createAction, props } from '@ngrx/store';
import { Status } from '@core/models'

export const STATUS_FIND = createAction('[State] Find');
export const STATUS_FIND_SUCCESS = createAction('[State] Find Success', props<{ statusList: Status[] }>());

export const STATUS_FAILURE = createAction('[State] Failure', props<{ error: string }>());
export const STATUS_UPDATE_LOADING = createAction('[State] Update Loading', props<{ loading: boolean }>());

